import { useMemo } from 'react';
import { getEventPhase, resolveCustomHomeSections, resolveEventHomeLayout, type EventPhase } from '@conference/shared';
import { useApp } from '../context/AppContext';

export function useEventHomeLayout(now = new Date()) {
  const app = useApp();
  const { currentEventId, selectedEvent, isSelectedEventLoading } = app;
  const event = selectedEvent?.id === currentEventId ? selectedEvent : null;
  const hasSelectedEventState = Object.prototype.hasOwnProperty.call(app, 'selectedEvent');
  const isReady = Boolean(event) || (!isSelectedEventLoading && (!currentEventId || !hasSelectedEventState));
  const isLegacy = !event?.home_layout || Object.keys(event.home_layout).length === 0;
  const phase: EventPhase = event ? getEventPhase(event, now) : 'before';
  const blocks = useMemo(() => {
    if (!isReady || !event) return [];
    return resolveEventHomeLayout(event.home_layout, event.app_modules, phase);
  }, [event, isReady, phase]);
  const customSections = useMemo(() => {
    if (!isReady || !event) return [];
    return resolveCustomHomeSections(event.home_layout, event.app_modules, phase);
  }, [event, isReady, phase]);

  return { phase, blocks, customSections, isReady, isLegacy };
}
